import { colorPalette } from "@shared/config/colorsConfig";

export type TReadingTone = 'done' | 'extra' | 'missed';

export const READING_TONE_STYLES: Record<TReadingTone, { iconBg: string; iconColor: string; title: string; time: string; dashedIcon?: boolean }> = {
    done: {
        iconBg: colorPalette.success[100],
        iconColor: colorPalette.success[500],
        title: 'text-black',
        time: 'text-success-500',
    },
    extra: {
        iconBg: colorPalette.secondary[100],
        iconColor: colorPalette.secondary[600],
        title: 'text-black',
        time: 'text-black',
    },
    missed: {
        iconBg: colorPalette.gray[200],
        iconColor: colorPalette.gray[500],
        title: 'text-gray-500',
        time: 'text-gray-500',
        dashedIcon: true,
    },
};
